module.exports = __webpack_public_path__ + "img/channels.28b6b1cd.svg";